import './App.css';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import Projects from './pages/Projects';
import Contact from './pages/Contact';
import NotFound from './pages/NotFound';

function App() {
	return (
		<div className='app-container'>
			<Router>
				<header className='app-header'>
					<Header />
				</header>
				<div className='app-content'>
					<Routes>
						<Route path='/' element={<Home />} />
						<Route path='/about' element={<About />} />
						<Route path='/projects' element={<Projects />} />
						<Route path='/contact' element={<Contact />} />
						<Route path='*' element={<NotFound />} />
					</Routes>
				</div>
				<footer className='app-footer'>
					<Footer />
				</footer>
			</Router>
		</div>
	);
}

export default App;
